import { render, staticRenderFns } from "./cart-items.vue?vue&type=template&id=756c937e&scoped=true&"
import script from "./cart-items.vue?vue&type=script&lang=js&"
export * from "./cart-items.vue?vue&type=script&lang=js&"
import style0 from "./cart-items.vue?vue&type=style&index=0&id=756c937e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c937e",
  null
  
)

export default component.exports